import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import { Card, CardContent, Grid, styled } from '@mui/material';
import { useEffect, useState } from 'react';
import { getAuditLogsById } from 'wisestep-api';
import {
  WsTypography,
  WsTypoVariants,
  WsTypoColors,
  WsButton,
  formatDateForTaskCard,
  WsColors,
} from 'wisestep-base';

interface IUpdatedDetailsPreview {
  onClose: (action: boolean) => void;
  auditId: string;
}

interface IUpdatedFields {
  newValue: string;
  oldValue: string;
  columnName: string;
}

interface IAuditLog {
  id: string;
  workspaceId: string;
  entityName: string;
  entityId: string;
  action: string;
  modifiedBy: string;
  modifiedOn: string;
  updatedFields: string;
}

const UpdatedDetailsPreview = ({ onClose, auditId }: IUpdatedDetailsPreview) => {
  const StyledCard = styled(Card)({
    borderRadius: 5,
    maxHeight: 'auto',
    overflowY: 'auto',
  });
  const [updatedFieldData, setUpdatedFieldData] = useState<IUpdatedFields[]>([]);
  const [dateAndTime, setDateAndTime] = useState<string>('');
  const [auditLogs, setAuditLogs] = useState<IAuditLog>();
  useEffect(() => {
    (async () => {
      if (auditId) {
        const response = await getAuditLogsById(auditId);
        setAuditLogs(response.data);
      }
    })();
  }, [auditId]);

  useEffect(() => {
    if (auditLogs) {
      setDateAndTime(formatDateForTaskCard(auditLogs.modifiedOn));
      setUpdatedFieldData(JSON.parse(auditLogs.updatedFields));
    }
  }, [auditLogs]);

  const camelCaseToNormal = (text: string): string => {
    return text
      .replace(/([A-Z])/g, ' $1')
      .replace(/^./, (str) => str.toUpperCase())
      .trim();
  };

  return (
    <StyledCard sx={{ bgcolor: 'transparent' }}>
      <Grid container alignItems="center" justifyContent="space-between" p={1}>
        <WsTypography variant={WsTypoVariants.TITLE} color={WsTypoColors.BLACK}>
          Preview
        </WsTypography>
        <WsButton size="medium" variant="outlined" type="submit" onClick={() => onClose(false)}>
          Close
        </WsButton>
      </Grid>
      <StyledCard sx={{ bgcolor: 'white' }}>
        <Grid container direction="row" alignItems="center" spacing={2} mt={2} p={1} xs={12}>
          <Grid item xs={12}>
            <WsTypography variant={WsTypoVariants.BODY2} color={WsTypoColors.BLACK}>
              {dateAndTime}
            </WsTypography>
          </Grid>
          <Grid item xs={12}>
            <WsTypography variant={WsTypoVariants.BODY1} color={WsTypoColors.BLACK}>
              Updated Details
            </WsTypography>
          </Grid>
          {updatedFieldData.map((item, index) => (
            <Grid item xs={12} key={index}>
              <Card variant="elevation" sx={{ bgcolor: WsColors.BackGround }}>
                <CardContent>
                  <WsTypography variant={WsTypoVariants.BODY1}>
                    <strong>Changed</strong> {camelCaseToNormal(item.columnName)}
                  </WsTypography>
                  <WsTypography color={WsTypoColors.BLACK} variant={WsTypoVariants.BODY1}>
                    <span style={{ textDecoration: 'line-through' }}>{item.oldValue}</span>
                    <ArrowForwardIcon sx={{ mx: 1, fontSize: 20, mb: -0.6 }} />
                    {item.newValue}
                  </WsTypography>
                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      </StyledCard>
    </StyledCard>
  );
};

export default UpdatedDetailsPreview;
